// extracted by mini-css-extract-plugin
export default {"searchIcon":"searchIcon_Bjhdh6ix","searchIcon__search-banner":"searchIcon__search-banner_UZsKn3_l","searchIcon__non-search-banner":"searchIcon__non-search-banner_pFSgoCg3"};